module.exports = __webpack_public_path__ + "static/media/bourse-bg.771f6472.jpg";